import { render, staticRenderFns } from "./delete-user-overlay.vue?vue&type=template&id=769b4805"
import script from "./delete-user-overlay.vue?vue&type=script&lang=js"
export * from "./delete-user-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports